import { useAppDispatch, useAppSelector } from "app/hooks";
import { setMeasureMode } from "features/krpano/details-slice";
import { useEffect } from "react";
import { notNullNorUndefined } from "shared/helpers/notNullNorUndefined";

const MEASURE_MODE_ON = "enter_measuring_mode();";
const MEASURE_MODE_OFF = "exit_measuring_mode(true);";

type UseMeasureMode = (krpanoFeaturesReady: boolean) => void;

/**
 * # Measure mode (toggle) control for krpano
 *
 * @param krpanoFeaturesReady see `AppInner`
 */
export const useMeasureMode: UseMeasureMode = (krpanoFeaturesReady) => {
  const measureMode = useAppSelector((state) => state.krpano.measureMode);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (krpanoFeaturesReady) {
      switch (measureMode) {
        case "IN_PROGRESS":
          window.krpano.call(MEASURE_MODE_ON);
          break;
        case "ACTIVE":
          // window.krpano.call(MEASURE_MODE_ON);
          break;
        case null:
        default:
          window.krpano.call(MEASURE_MODE_OFF);
          break;
      }
    }
  }, [krpanoFeaturesReady, measureMode]);

  // This listener is for when krpano is used to change measure-mode
  useEffect(() => {
    const setMeasureModeHandler = (
      event: WindowEventMap["krpano__measure_mode"]
    ) => {
      if (
        notNullNorUndefined(event.detail) &&
        event.detail.measureMode !== undefined
      ) {
        dispatch(setMeasureMode(event.detail.measureMode));
      } else {
        // TODO: KrpanoDispatchedEvent Error handling
      }
    };
    window.addEventListener("krpano__measure_mode", setMeasureModeHandler);
    return () => {
      window.removeEventListener("krpano__measure_mode", setMeasureModeHandler);
    };
  }, [dispatch]);
};
